var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.label,"value":_vm.value,"items":_vm.items,"item-value":_vm.itemValue},on:{"change":_vm.handleSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }